import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiAgeFilterConfig } from '@/data/landingConfig/landingAiAgeFilterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiAgeFilter } from './schemaObject';

interface Props {}
const AiAgeFilter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiAgeFilter} />
			<LandingTemplate
				data={landingAiAgeFilterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAgeProgression()}
			/>
		</>
	);
};

export default AiAgeFilter;
